"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M21.5 19.963a1 1 0 0 1-.685.986c-.786.26-1.592.386-2.441.277-.85-.109-1.675-.443-2.515-1.003a.17.17 0 0 0-.166-.014A9 9 0 1 1 21 12c0 1.893-.87 3.553-1.553 4.855q-.16.303-.3.579c-.164.364-.106.589.04.783.2.264.669.592 1.555.814a1 1 0 0 1 .757.932M7 11.485C7 14.494 12 17 12 17s5-2.506 5-5.514c0-3.007-3.889-3.258-5-.905-1.111-2.353-5-2.102-5 .905"
}), 'BubbleHeartFilled');
//# sourceMappingURL=index.js.map